/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route, Routes } from 'react-router-dom'
import { ErrorsLayout } from './ErrorsLayout'
import { Error404 } from './components/Error404'
import { Error500 } from './components/Error500'
import { ErrorMember } from './components/ErrorMember'
import { ErrorStore } from './components/ErrorStore'
import { ErrorTerminal } from './components/ErrorTerminal'

const ErrorsPage = () => (
  <Routes>
    <Route element={<ErrorsLayout />}>
      <Route path='404' element={<Error404 />} />
      <Route path='500' element={<Error500 />} />
      <Route path='store' element={<ErrorStore />} />
      <Route path='member' element={<ErrorMember />} />
      <Route path='terminal' element={<ErrorTerminal />} />
      <Route index element={<Error404 />} />
    </Route>
  </Routes>
)

export { ErrorsPage }

